<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <section class="flex flex-col items-center gap-6">
    <div>
      <tui-badge appearance="neutral" iconStart="@tui.badge-check" size="xl">
        No spam, promise!
      </tui-badge>
    </div>
    <div class="flex flex-col gap-14">
      <h1 class="text-center text-4xl font-bold leading-relaxed md:text-5xl">
        @defer {
          Subscribe to our
          <span
            [roughNotation]="{
              animate: true,
              animationDelay: 500,
              strokeWidth: 3,
              iterations: 4,
              type: 'underline',
              color: 'var(--tui-background-accent-2)',
              padding: 2,
            }"
            >newsletter</span
          >
        } @placeholder {
          Subscribe to our newsletter
        }
      </h1>
      <p class="w-full text-balance text-center text-xl leading-snug">
        The Capawesome Newsletter is a monthly newsletter of the latest updates,
        features, and news about the Capawesome, Capacitor, and Ionic ecosystem.
        Hear from featured guests about how to build your best apps and keep
        your users happy.
      </p>
      <form
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit()"
        class="mx-auto w-full md:w-2/3 lg:w-1/2"
      >
        <div class="tui-form__row">
          <div tuiGroup>
            <div>
              <tui-textfield [style.border-radius]="'inherit'">
                <label tuiLabel>Email <span class="tui-required"></span></label>
                <input [formControl]="formGroup.controls.email" tuiTextfield />
              </tui-textfield>
              <tui-error
                formControlName="email"
                [error]="[] | tuiFieldError | async"
              />
            </div>
            <button
              tuiButton
              type="submit"
              [style.flex]="'0 0 auto'"
              [loading]="subscribeNewsletter.isPending()"
            >
              Subscribe
            </button>
          </div>
        </div>
        <div class="tui-form__row">
          <label tuiLabel class="flex items-center gap-2">
            <input
              formControlName="terms"
              tuiCheckbox
              type="checkbox"
              [size]="'m'"
            />
            <span class="tui-text_body-m">
              I've read and accept the
              <a
                href="https://capawesome.io/privacy/"
                target="_blank"
                class="text-[color:var(--tui-text-action)]"
                >Privacy Policy</a
              >. <span class="tui-required"></span>
            </span>
          </label>
          <tui-error
            formControlName="terms"
            [error]="[] | tuiFieldError | async"
          ></tui-error>
        </div>
      </form>
    </div>
  </section>
</div>
